<div class="survey-banner">
  <div class="background-wrapper">
    <div class="tellent-brands-container"></div>
    <div class="wrapper">
      <div class="content">
        <span class="title" [innerHTML]="title()"></span>
        <span class="description">{{ description() }}</span>
        <rt-button variant="tellent" class="start-button" (click)="ctaClicked.emit()">
          {{ buttonText() }}
        </rt-button>
      </div>
      <rt-icon-button
        (click)="hideClicked.emit()"
        variant="transparent-light"
        iconName="close"
        class="close-button"
      >
      </rt-icon-button>
    </div>
  </div>
</div>
